<app-bar-chart
  [labels]="labels"
  [series]="series"
  [loading]="isLoading"
  [title]="'Event Types Over Time'"
  [chartType]="'bar'"
  [options]="options"
  [translateLabels]="true"
></app-bar-chart>
